import { Flex, Text } from '@mediahuis/chameleon-react';
import { MultibrandIcon } from "../MultibrandIcon/index.js";
import { MultibrandLogos } from "../MultibrandLogos/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const sortedBrands = ['nb', 'ds', 'gva', 'hbvl', 'dg'];
const MultibrandBannerInline = _ref => {
  let {
    activeBrand,
    style,
    text
  } = _ref;
  const hasActiveBrand = Boolean(activeBrand);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    bgColor: "colorGrey10",
    justifyContent: "space-between",
    px: 4,
    py: 2,
    style: style,
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      style: {
        gap: '8px'
      },
      children: [hasActiveBrand && /*#__PURE__*/_jsx(MultibrandIcon, {
        icon: "plusBlack",
        height: "12px",
        width: "12px"
      }), /*#__PURE__*/_jsx(Text, {
        fontFamily: "system",
        size: "Caption2",
        children: text
      })]
    }), hasActiveBrand && /*#__PURE__*/_jsx(MultibrandLogos, {
      brands: sortedBrands.filter(brand => brand !== activeBrand),
      size: "sm"
    })]
  });
};
export default MultibrandBannerInline;